import TortasMaster from './TortasMaster'
export default class FacturaPie extends TortasMaster {
    state = { title: '', values: [] };
    estados = ['CANCELADO', '', 'FACTURADA'];
    api = 'Factura';
    title='FACTURAS'
}